import { Input, InputRef } from 'antd';
import Modal from 'components/Modal';
import CurrencyKeyBoard, { useCurrencyKeyBoardRef } from 'components/NumberKeyBoard/Currency';
import Text from 'components/Text';
import cashierActions from 'features/cashier/services/actions';
import cashierSelectors from 'features/cashier/services/selectors';
import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';

const UpdateQuickPay = () => {
  const inputRef = useCurrencyKeyBoardRef();
  const inputNameRef = useRef<InputRef>(null);
  const dispatch = useAppDispatch();
  const draffQuickPay = cashierSelectors.getDraftQuickPay();
  const [amount, setAmount] = useState<number | null>();
  const [serviceName, setServiceName] = useState<string>('');
  const handleClose = () => dispatch(cashierActions.setDraftQuickPay(null));

  useEffect(() => {
    if (!draffQuickPay) return;
    setServiceName(draffQuickPay.itemName);
    setTimeout(() => {
      if (draffQuickPay.typeDraft === 'PRICE')
        inputRef.current?.setValue(0?.toFixed(2));
      else {
        inputNameRef.current?.focus();
        inputRef.current?.setValue(draffQuickPay.value?.toFixed(2), true);
      }
    }, 100);
  }, [draffQuickPay]);

  const handleSubmit = () => {
    if (
      !draffQuickPay ||
      (amount === draffQuickPay?.value && draffQuickPay?.itemName === serviceName)) {
      handleClose();
      return;
    }

    dispatch(cashierActions.updateQuickPayItem({
      staffId: draffQuickPay.staffId || '',
      itemId: draffQuickPay.itemId || '',
      value: amount || 0,
      itemName: serviceName || draffQuickPay.itemName || '',
      typeDraft: draffQuickPay.typeDraft,
    }));
  };

  return (
    <Modal
      visible={!!draffQuickPay}
      onClose={handleClose}
      modalTitle={draffQuickPay?.itemName || 'UPDATE SERVICE'}
      okTitle="Done"
      onSubmit={handleSubmit}
      disableOk={!amount}
    >
      <ServiceName>
        <Text style={{ fontSize: '1.2rem' }} mb={0.5}>
          Service Name:
        </Text>
        <Input ref={inputNameRef} size='small' value={serviceName} onChange={e => setServiceName(e.target.value)} />
      </ServiceName>
      <CurrencyKeyBoard smallInput ref={inputRef} onChange={setAmount} value={amount} />
    </Modal>
  );
};

export default UpdateQuickPay;

const ServiceName = styled.div`
  margin-bottom: 1rem;
`;